import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article' | 'figure';
};
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className,
  as = 'div'
}: RevealProps) {
  const Motion = motion[as];
  return <Motion className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.9,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-135" data-mp="3gfxlgs4epei4">
      {children}
    </Motion>;
}